import { Boundaries } from "@planzone/core";
import { events } from "@planzone/events";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { createStateReducer } from "../../utils/createStateReducer";
import { resetState } from "../../utils/resetState";
import { State, Selector } from "./types";
import { createSelector } from "./selector";

const initialState: State = [];

function handleRequest(
  state: State,
  { resource }: Boundaries["removeResourceFromPlanzone"]["request"],
): State {
  const index = state.findIndex((res) => res.resource.uuid === resource.uuid);

  return [
    ...state.slice(0, index),
    { resource, request: setRequestStateToPending() },
    ...state.slice(index + 1),
  ];
}

function handleSuccess(
  state: State,
  { resource }: Boundaries["removeResourceFromPlanzone"]["success"],
): State {
  return state.map((res) =>
    res.resource.uuid === resource.uuid
      ? { ...res, request: setRequestStateToSuccess() }
      : res,
  );
}

function handleFailure(
  state: State,
  { resource }: Boundaries["removeResourceFromPlanzone"]["failure"],
): State {
  return state.map((res) =>
    res.resource.uuid === resource.uuid
      ? { ...res, request: setRequestStateToFailure() }
      : res,
  );
}

const reduceState = resetState(
  initialState,
  createStateReducer(initialState, {
    [events.removeResourceFromPlanzoneRequested]: handleRequest,
    [events.removeResourceFromPlanzoneSucceeded]: handleSuccess,
    [events.removeResourceFromPlanzoneFailed]: handleFailure,
  }),
  [events.changePlanzoneSucceeded],
);

export type { State, Selector };

export { reduceState, initialState, createSelector };
